// menu.js — Menü am body (nie abgeschnitten), Tastatur nach WAI-ARIA, auf compact als Bottom-Sheet.
//   openMenu(anchor, [{ value, label, icon, trail, danger, disabled, group, divider }], { selected, role, onSelect, sheet })
import { html, render } from '../core/h.js';
import { reducedMotion } from '../core/dom.js';

let current = null;
const isCompact = () => window.matchMedia('(max-width: 599px)').matches;

export function closeMenu(reason) { if (current) current.close(reason); }

export function openMenu(anchor, items, { selected, role = 'menu', onSelect, onClose, sheet = isCompact(), label, trigger = anchor } = {}) {
  closeMenu('replaced');
  const list = document.createElement('div');
  list.className = 'vc-menu' + (sheet ? ' is-sheet' : '');
  list.setAttribute('role', role === 'listbox' ? 'listbox' : 'menu');
  if (label) list.setAttribute('aria-label', label);
  const itemRole = role === 'listbox' ? 'option' : 'menuitem';
  render(list, html`${items.map((it, i) => it.divider ? html`<div class="vc-menu-divider" role="separator"></div>`
    : it.group ? html`<div class="vc-menu-group" role="presentation">${it.group}</div>`
    : html`<button type="button" class="vc-menu-item${it.danger ? ' is-danger' : ''}" role="${itemRole}" data-i="${i}" tabindex="-1"
        aria-selected="${role === 'listbox' ? String(it.value === selected) : null}" aria-disabled="${it.disabled ? 'true' : null}">
        ${it.icon ? html`<span class="vc-icon" aria-hidden="true">${it.icon}</span>` : ''}<span>${it.label}</span>
        ${it.trail ? html`<span class="vc-menu-trail">${it.trail}</span>` : ''}
        ${role === 'listbox' && it.value === selected ? html`<span class="vc-icon vc-menu-check" aria-hidden="true">check</span>` : ''}
      </button>`)}`);
  let scrim = null;
  if (sheet) { scrim = document.createElement('div'); scrim.className = 'vc-menu-scrim'; document.body.appendChild(scrim); }
  document.body.appendChild(list);
  const buttons = [...list.querySelectorAll('.vc-menu-item:not([aria-disabled="true"])')];

  if (!sheet) position(list, anchor);
  trigger.setAttribute('aria-expanded', 'true');

  let closed = false;
  const close = (reason) => {
    if (closed) return;
    closed = true; current = null;
    trigger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('pointerdown', outside, true);
    removeEventListener('resize', reflow); removeEventListener('scroll', reflow, true);
    const done = () => { list.remove(); if (scrim) scrim.remove(); };
    if (reducedMotion()) done(); else { list.classList.add('is-closing'); setTimeout(done, 160); }
    if (reason !== 'replaced' && reason !== 'outside' && trigger.focus) trigger.focus({ preventScroll: true });
    if (onClose) onClose(reason);
  };
  const choose = (btn) => {
    const it = items[Number(btn.dataset.i)];
    if (!it || it.disabled) return;
    close('select');
    if (onSelect) onSelect(it.value, it);
  };
  const outside = (e) => { if (!list.contains(e.target) && !anchor.contains(e.target) && !trigger.contains(e.target)) close('outside'); };
  const reflow = () => { if (!sheet) position(list, anchor); };
  list.addEventListener('click', (e) => { const b = e.target.closest('.vc-menu-item'); if (b) choose(b); });
  let typed = '', typedT = 0;
  list.addEventListener('keydown', (e) => {
    const i = buttons.indexOf(document.activeElement);
    const go = (n) => { const b = buttons[(n + buttons.length) % buttons.length]; if (b) b.focus(); };
    if (e.key === 'ArrowDown') { e.preventDefault(); go(i + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); go(i - 1); }
    else if (e.key === 'Home') { e.preventDefault(); go(0); }
    else if (e.key === 'End') { e.preventDefault(); go(buttons.length - 1); }
    else if (e.key === 'Escape') { e.preventDefault(); close('escape'); }
    else if (e.key === 'Tab') { close('tab'); }
    else if (e.key.length === 1 && /\S/.test(e.key)) {
      const now = Date.now(); typed = (now - typedT > 700 ? '' : typed) + e.key.toLowerCase(); typedT = now;
      const hit = buttons.find((b) => b.textContent.trim().toLowerCase().startsWith(typed));
      if (hit) hit.focus();
    }
  });
  if (scrim) scrim.addEventListener('click', () => close('outside'));
  setTimeout(() => document.addEventListener('pointerdown', outside, true));
  addEventListener('resize', reflow); addEventListener('scroll', reflow, true);
  const start = buttons.find((b) => b.getAttribute('aria-selected') === 'true') || buttons[0];
  if (start) start.focus({ preventScroll: true });
  if (start && start.scrollIntoView) start.scrollIntoView({ block: 'nearest' });
  current = { close };
  return current;
}

function position(list, anchor) {
  const r = anchor.getBoundingClientRect();
  const vw = document.documentElement.clientWidth, vh = window.innerHeight;
  list.style.minWidth = Math.max(112, r.width) + 'px';
  const h = list.offsetHeight, w = list.offsetWidth;
  const below = vh - r.bottom - 8, above = r.top - 8;
  const up = h > below && above > below;
  const top = up ? Math.max(8, r.top - h - 4) : Math.min(vh - h - 8, r.bottom + 4);
  const left = Math.min(Math.max(8, r.left), vw - w - 8);
  list.style.top = top + 'px'; list.style.left = left + 'px';
  list.style.setProperty('--_origin', up ? 'bottom left' : 'top left');
}
